'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'staff-snake';
var width = 384;
var height = 512;
var aliases = ["rod-asclepius","rod-snake","staff-aesculapius"];
var unicode = 'e579';
var svgPathData = 'M222.5 48H296C344.6 48 384 87.4 384 136C384 184.6 344.6 224 296 224H248V176H296C318.1 176 336 158.1 336 136C336 113.9 318.1 96 296 96H220.1L214.1 288H240C284.2 288 320 323.8 320 368C320 412.2 284.2 448 240 448V400C257.7 400 272 385.7 272 368C272 350.3 257.7 336 240 336H213.5L208.5 496C208.2 504.9 200.9 512 191.1 512C183.1 512 175.8 504.9 175.5 496L173.1 448H119.1C106.7 448 95.1 437.3 95.1 424C95.1 410.7 106.7 400 119.1 400H172.5L170.5 336H144C99.82 336 64 300.2 64 256C64 214.5 95.57 180.4 136 176.4V225C122.2 228.6 112 241.1 112 256C112 273.7 126.3 288 144 288H169L163 96H127.4C127.8 98.61 128 101.3 128 104C128 134.9 102.9 160 72 160H56C25.07 160 0 134.9 0 104C0 73.07 25.07 48 56 48H161.5L160.1 31.98C160.1 31.33 160.1 30.69 160.1 30.05C161.5 13.43 175.1 0 192 0C208.9 0 222.5 13.43 223 30.05C223 30.69 223 31.33 223 31.98L222.5 48zM79.1 96C79.1 87.16 72.84 80 63.1 80C55.16 80 47.1 87.16 47.1 96C47.1 104.8 55.16 112 63.1 112C72.84 112 79.1 104.8 79.1 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStaffSnake = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;